// extracted by mini-css-extract-plugin
export var headline6 = "br_dC";
export var menuContainer = "br_dy";
export var menuItem = "br_dB";
export var menuList = "br_dz";